import { Localization } from 'material-table';

const localizations: Localization = {
  header: {
    actions: 'Acciones'
  },
  toolbar: { searchTooltip: 'Buscar', searchPlaceholder: 'Buscar' },
  body: {
    emptyDataSourceMessage: '0 registros encontrados',
    filterRow: {
      filterTooltip: 'Filtrar'
    },
    editRow: {
      cancelTooltip: 'Cancelar',
      saveTooltip: 'Guardar'
    }
  },
  pagination: {
    labelDisplayedRows: '{from}-{to} de {count}',
    firstAriaLabel: 'Ir al inicio',
    firstTooltip: 'Ir al inicio',
    previousAriaLabel: 'Anterior',
    previousTooltip: 'Anterior',
    nextAriaLabel: 'Siguiente',
    nextTooltip: 'Siguiente',
    lastAriaLabel: 'Ir al final',
    lastTooltip: 'Ir al final',
    labelRowsPerPage: 'filas',
    labelRowsSelect: 'filas'
  }
};

export function combineLocalizations(texts: Localization): Localization {
  return {
    header: {
      ...localizations.header,
      ...texts.header
    },
    toolbar: {
      ...localizations.toolbar,
      ...texts.toolbar
    },
    body: {
      ...localizations.body,
      ...texts.body
    },
    pagination: {
      ...localizations.pagination,
      ...texts.pagination
    }
  };
}

export default localizations;
